import { Nullable } from '../types/utilities.types';
import { keepTruthy } from './dataStructure.utils';

export const joinClassNames = (...classNames: Nullable<string>[]) => {
  return keepTruthy(...classNames).join(' ');
}

// TODO media queries, etc.